import React from 'react';
import { string, object, mixed } from 'yup';
import PropTypes from 'prop-types';
import { Card, CardFooter, CardBody } from 'reactstrap';
import { Button, Form as BaseForm } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  usePatient,
  formikValidate as validate,
} from '~/utils';
import { store } from '~/utils/care-giver';
import Fields from './Fields';

const validationSchema = object().shape({
  firstName: string().required(),
  lastName: string().required(),
  relationship: mixed().required(),
  patient: mixed().required(),
  email: string().email().nullable(),
});

const Form = ({ data, disabled }) => {
  const history = useHistory();
  const [, patient] = usePatient();

  return (
    <BaseForm
      displayName="CareGiverForm"

      initialValues={{
        firstName: '',
        lastName: '',
        isCurrent: true,
        isPrimary: false,
        patientConsents: false,
        preferredPhoneType: 'N/A',
        roles: [],
        ...data,
        otherRoles: data.roles?.filter(r => !store.support.roles.includes(r)).join(', '),
        relationship: data?.relationship
          ? { value: data.relationship, label: data.relationship }
          : null,
        patient,
      }}

      onSubmit={(values, actions) => {
        return validate(values, validationSchema)
          .then((validatedPayload) => {
            const { id, ...v } = validatedPayload;
            const method = id ? store.put : store.post;
            return method({ values: v, id, options: { patient: values.patient.id } })
              .then(() => toast.success('Successfully Saved!'))
              .then(() => history.push(`/patients/${values.patient.id}/care-team`))
              .catch((e) => actions.setErrors({ server: e.errors }));
          })
          .catch(e => {
            actions.setErrors(e);
            actions.setTouched(e); // needed for validation errors to show
          })
          .finally(() => actions.setSubmitting(false));
      }}
    >
      {({
        isSubmitting,
      }) => (
        <Card>
          <CardBody className="p-0">
            <Fields disabled={disabled} />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="button"
                color="tertiary"
                outline
                icon="times"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>

              <Button type="submit" disabled={disabled || isSubmitting}>
                {isSubmitting ? 'Working ...' : 'Save'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </BaseForm>
  );
};

Form.propTypes = {
  data: PropTypes.shape(),
  disabled: PropTypes.bool,
};

Form.defaultProps = {
  data: {},
  disabled: false,
};

export default Form;
